import { atom } from 'jotai/index';
import { $CurrentHashtagId } from '@hashtag/shared/current-hashtag';
import { $HashtagInfo } from 'shared/atoms';
import { HashtagInfoUtil, IHashtagInfo } from 'shared/models/hashtag';

export const $CurrentHashtagInfo = atom((get) => {
  const currentHashtagId = get($CurrentHashtagId);
  return get($HashtagInfo(currentHashtagId));
});

export const $CurrentHashtagInfoOrNull = atom((get) => {
  const hashtagInfo = get($CurrentHashtagInfo);
  if (HashtagInfoUtil.isAvailable(hashtagInfo)) {
    return hashtagInfo;
  }
  return null;
});

export const $CurrentHashtagInfoAsAvailable = atom((get) => {
  const currentHashtagId = get($CurrentHashtagId);
  return get($HashtagInfo(currentHashtagId)) as IHashtagInfo;
});
